// extracted by mini-css-extract-plugin
export var legendIndicator = "_ap-1";
export var legendRight = "_ap-0";